import { IApplicationState } from '../../types/redux';
import { IBanner } from '../../types/banners';

export function getBannersByRegionId(state: IApplicationState): IBanner[] {
  const {
    locations: { hash: locationsHash },
    filter: { location },
    banners: { hash: bannersHash },
  } = state;
  const bannerIds = locationsHash[location].bannerIds || [];

  return bannerIds.map(id => bannersHash[id]);
}
